import React from "react";

const BLOCKS = [
  {
    emoji: "🐕", title: "Dog Walker (free)", color: "border-sky-300",
    text: "Neighbors like Mrs. Parker and Mr. Chen ask you to walk their dogs. Look at the size of the pup and the length of the walk, pick a fair price, then keep the leash steady while dodging squirrels and collecting bones. A safe, happy walk earns a 5-star review.",
  },
  {
    emoji: "🧸", title: "Babysitter", color: "border-violet-300",
    text: "Parents need a responsible kid to watch the little ones. Keep snacks coming, toys tidy and everyone giggling until pickup time. Babysitting pays well, but the safety rules matter most — a calm, careful sitter gets asked back.",
  },
  {
    emoji: "🎨", title: "Craft Maker", color: "border-pink-300",
    text: "Buy beads, string and paper from the supply shop, then make bracelets, cards and keychains. Here you learn the hardest lesson in business: your price has to cover what the supplies cost, or you lose money on every sale.",
  },
  {
    emoji: "🌱", title: "Lawn Mower", color: "border-emerald-300",
    text: "The biggest jobs on the street. Mow neat stripes across the yard, steer around flower beds and rocks, and finish before the timer runs out. Fuel and blades are expenses, so smart bosses price bigger yards higher.",
  },
];

const InsideTheGame = () => (
  <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-testid="landing-inside">
    <div className="grid lg:grid-cols-12 gap-8">
      <div className="lg:col-span-4">
        <div className="text-xs font-black uppercase tracking-widest text-amber-600 mb-2">Inside the game</div>
        <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold text-slate-900 tracking-tight">A whole neighborhood of customers</h2>
        <p className="mt-4 text-sm sm:text-base text-slate-600 font-medium leading-relaxed">
          Each in-game day brings new customer requests with a story, a budget and sometimes a safety warning. You decide which jobs to take, what to charge and how to grow.
          At the end of the day you see your income, your expenses and your profit, drop some cash into the piggy bank, and unlock trophies.
        </p>
        <p className="mt-3 text-sm sm:text-base text-slate-600 font-medium leading-relaxed">
          Between jobs, hand out flyers to attract more customers, design a real flyer to print, give your business a custom name and logo, and read short business lessons with quizzes that pay bonus cash.
        </p>
      </div>
      <div className="lg:col-span-8 grid sm:grid-cols-2 gap-4">
        {BLOCKS.map((b, i) => (
          <article key={b.title} className={`bg-white rounded-3xl border-2 ${b.color} p-5 card-3d animate-pop-in`} style={{ animationDelay: `${i * 100}ms` }} data-testid={`landing-inside-${i + 1}`}>
            <div className="flex items-center gap-3 mb-2">
              <span className="text-3xl">{b.emoji}</span>
              <h3 className="font-display text-lg sm:text-xl font-bold text-slate-900">{b.title}</h3>
            </div>
            <p className="text-sm text-slate-600 font-medium leading-relaxed">{b.text}</p>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default InsideTheGame;
